import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, compressImageFile, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import WSButton from "../../../Components/Button/WSButton";
import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import config from "../../../Config/config.json";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
interface SpecializationProps {
  control: any;
  register: any;
  setValue: any;
  reset: any;
  id?: string;
  onCancel?: () => void;
  data?: any
}
export const Specialization: React.FC<any> = React.memo(
  (props) => {
    const { showMessage } = useSnackbar();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
    const navigate = useNavigate();
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [imageUrl, setImageUrl] = useState<any>([]);
    useEffect(() => {
      updateMainHeader("Specialization");

      breadCrumbsStore.updateBreadCrumbs([
        { "Specialization List": "/specialization/list" },
        {
          [!id ? "Add Specialization" : "Update Specialization"]:
            "/specialization/create",
        },
      ]);
    }, [id]);

    useEffect(() => {
      async function getSpecializationById(recordId: any) {
        try {
          const response: any = await callAPI("Specialization", Method.GET, {}, recordId);
          if (response?.data) {
            setValue("specializations", response.data.specializations);
            setValue("specializationId", response.data.id);
            for (const field in response.data) {
              if (
                field === "imageUrl" &&
                response?.data[field] !== null
              ) {
                setImageUrl(
                  `${config.imgUrl}${response?.data[field].replace(
                    "UploadedImages/",
                    ""
                  )}`
                );
              }
            }
          }
        } catch (error) {
          console.log("failed to retrieve data", error);
        }
      }
      if (id) {
        getSpecializationById(id)
      }
    }, [id, reset, setValue]);
    const handleData = async (data: any) => {
      try {
        setLoading(true);

        const response: any = await saveData(data);
        if (response && response?.message) {

          showMessage(
            response.message,
            response.success === true ? "success" : "error"
          );
          if (response.success === true) {
            navigate(`/specialization/list`);
          }
        } else if (response?.id) {

          showMessage("specialization Created Successfully", "success");
          navigate(`/specialization/list`);
        }
      } catch (e: any) {
        showMessage(e.error);
      } finally {
        setLoading(false);
      }
    };
    const setRequest = async (data: any) => {
      const formData = new FormData();
      if (selectedFile) {
        formData.append("image", selectedFile!);
      }
      formData.append("specializations", data?.specializations || "");
      // if(data?.description){
      //     formData.append("description", data?.description);
      // }
      return formData
    }
    const saveData = async (data: any) => {
      // const request: any = {
      //   specializations: data?.specializations || "",
      // };
      const request:any=await setRequest(data);
      if (data?.specializationId) {
        // const response: any = await callAPI(
        //   "Specialization",
        //   Method.PUT,
        //   request,
        //   data.specializationId
        // );
        const response: any = await callAPI(
          `Specialization/${data?.specializationId}`,
          Method.PUTFORMDATA,null,null,
          request,
        );
        return response;
      } else {
      //   const response: any = await callAPI(
      //     "Specialization",
      //     Method.POST,
      //     request
      //   );
      //   return response;
      // }
       const response: any = await callAPI(
          "Specialization",
          Method.POSTFORMDATA,null,null,
          request
        );
        return response;
      }
    };
    const handleCancelClick = () => {
      navigate('/specialization/list')
    }
    const handleDataSaveAndNew = async (data: any) => {
      try {
        setLoadingSaveAndNew(true);
        const response: any = await saveData(data);
        if (response && response?.message) {
          showMessage(
            response.message,
            response.success === true ? "success" : "error"
          );
          if (response.success === true) {
            reset();
          }
        } else if (response?.id) {
          reset();
        }
      } catch (e: any) {
        showMessage(e.error);
      } finally {
        setLoadingSaveAndNew(false);
      }
    };
    const handleUploadChange = async (uploadedFile: any) => {
      const file: any = uploadedFile[0];
      try {
        let newFile: any = await compressImageFile(uploadedFile);
        setSelectedFile(newFile);
      } catch (error) {
        showMessage("Error converting file to base64:", "error");
      }
    };
    return (
      <Grid
        sx={{
          padding: 4,
          backgroundColor: "#fff",
          borderRadius: 2,
          border: "1px solid lightgrey",
          marginTop: 3,
        }}
      >
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <WSTextField
              label={"Name"}

              id="specializations"
              name="specializations"
              control={control}
              rules={{ required: true }}
            />
            <WSHiddenField control={control} name="specializationId" />
          </Grid>
            {/* <Grid item xs={12}>
            <WSTextAreaField
              label={"Descriptions"}
              id="description"
              name="description"
              control={control}
              rules={{ required: true }}
            />
          </Grid> */}
          <Grid item>
            <WSImageUpload
              control={control}
              id="image"
              name="image"
              label="Upload Image"
              rules={{ required: false }}
              onChange={handleUploadChange}
              imgUrl={imageUrl}
            />
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            spacing={2} // 16 px gap (2 × theme.spacing unit)
            sx={{ mt: 2 }}
          >
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>
            {!id && <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save & New"
                size="medium"
                variant="outlined"
                color="primary"
                loading={loadingSaveAndNew}
                onClick={handleSubmit(handleDataSaveAndNew)}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>}

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save"
                size="medium"
                variant="outlined"
                color="primary"
                loading={loading}
                onClick={handleSubmit(handleData)}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
